import { Host, h } from "@stencil/core";
export class GxgContainer {
    constructor() {
        this.fieldset = false;
        this.containerTitle = undefined;
        this.displayBorder = false;
        this.displayBorderTop = false;
        this.displayBorderEnd = false;
        this.displayBorderBottom = false;
        this.displayBorderStart = false;
        this.sectionsPadding = "m";
        this.noHeadingBorder = false;
        this.noHeadingPadding = false;
        this.headingJustify = "center";
        this.noContentPadding = false;
        this.noContentGap = false;
        this.noFooterPadding = false;
        this.footerJustify = "end";
        this.noBorderFooter = false;
        this.hasSlottedContent = false;
        this.hasFooterSlot = false;
        this.hasOnlyHeading = false;
        this.hasOnlyFooter = false;
    }
    /** *****************************
     * 2. REFERENCE TO ELEMENTS
     ********************************/
    el;
    /** *****************************
     4.PUBLIC PROPERTY API
     ********************************/
    /** *****************************
     *  5.EVENTS (EMMIT)
     ********************************/
    /** *****************************
     *  6.COMPONENT LIFECYCLE EVENTS
     ********************************/
    componentWillLoad() {
        this.evaluateSlots();
    }
    /** *****************************
     *  7.LISTENERS
     ********************************/
    /** *****************************
     *  8.PUBLIC METHODS API
     ********************************/
    /** *****************************
     *  9.LOCAL METHODS
     ********************************/
    evaluateSlots() {
        //content
        const slottedContent = this.el.querySelectorAll(":not([slot])");
        if (slottedContent.length) {
            this.hasSlottedContent = true;
        }
        //footer
        const footerSlot = this.el.querySelectorAll('[slot="footer"]');
        if (footerSlot.length) {
            this.hasFooterSlot = true;
        }
    }
    evaluateSections() {
        if (!this.hasSlottedContent && !this.hasFooterSlot) {
            this.hasOnlyHeading = true;
        }
        if (!this.hasSlottedContent && !this.containerTitle) {
            this.hasOnlyFooter = true;
        }
    }
    headingClasses = () => {
        return {
            heading: true,
            "heading--no-border": this.noHeadingBorder || this.hasOnlyHeading,
            [`heading--justify-${this.headingJustify}`]: true,
            ["heading--no-padding"]: this.noHeadingPadding,
        };
    };
    contentClasses = () => {
        return {
            content: true,
            "content--no-padding": this.noContentPadding,
            "content--no-gap": this.noContentGap,
        };
    };
    footer = () => {
        return this.hasFooterSlot ? (h("footer", { class: {
                footer: true,
                "footer--no-border": this.noHeadingBorder ||
                    this.hasOnlyFooter ||
                    !this.hasSlottedContent,
                [`footer--justify-${this.footerJustify}`]: true,
                [`footer--justify-${this.footerJustify}`]: true,
                ["footer--no-padding"]: this.noFooterPadding,
            } }, h("slot", { name: "footer" }))) : null;
    };
    /** *****************************
     *  10.RENDER() FUNCTION
     ********************************/
    render() {
        this.evaluateSections();
        let result;
        if (this.fieldset) {
            result = [
                h("fieldset", null, this.containerTitle ? (h("legend", { class: this.headingClasses() }, h("gxg-title", { type: "title-04" }, this.containerTitle))) : null, this.hasSlottedContent ? (h("div", { class: this.contentClasses() }, h("slot", null))) : null),
                this.footer(),
            ];
        }
        else {
            result = [
                this.containerTitle ? (h("header", { class: this.headingClasses() }, h("gxg-title", { type: "title-04" }, this.containerTitle))) : null,
                this.hasSlottedContent ? (h("div", { class: this.contentClasses() }, h("slot", null))) : null,
                this.footer(),
            ];
        }
        return (h(Host, { class: {
                "gxg-container": true,
                [`gxg-container--padding-${this.sectionsPadding}`]: true,
                "gxg-container--display-border": this.displayBorder,
                "gxg-container--display-border-top": this.displayBorderTop,
                "gxg-container--display-border-end": this.displayBorderEnd,
                "gxg-container--display-border-bottom": this.displayBorderBottom,
                "gxg-container--display-border-start": this.displayBorderStart,
            } }, result));
    }
    static get is() { return "gxg-container"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["container.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["container.css"]
        };
    }
    static get properties() {
        return {
            "fieldset": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Makes this component content act as a fieldset"
                },
                "attribute": "fieldset",
                "reflect": false,
                "defaultValue": "false"
            },
            "containerTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The title of the container"
                },
                "attribute": "container-title",
                "reflect": false
            },
            "displayBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Dsiplays a border all around the container"
                },
                "attribute": "display-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "displayBorderTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the component border on the top"
                },
                "attribute": "display-border-top",
                "reflect": false,
                "defaultValue": "false"
            },
            "displayBorderEnd": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the component border on the end"
                },
                "attribute": "display-border-end",
                "reflect": false,
                "defaultValue": "false"
            },
            "displayBorderBottom": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the component border on the bottom"
                },
                "attribute": "display-border-bottom",
                "reflect": false,
                "defaultValue": "false"
            },
            "displayBorderStart": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the component border on the start"
                },
                "attribute": "display-border-start",
                "reflect": false,
                "defaultValue": "false"
            },
            "sectionsPadding": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "sectionsPadding",
                    "resolved": "\"l\" | \"m\" | \"s\"",
                    "references": {
                        "sectionsPadding": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/container/container.tsx",
                            "id": "src/components/container/container.tsx::sectionsPadding"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The container general padding (applies to .heading, .content, and .footer)"
                },
                "attribute": "sections-padding",
                "reflect": false,
                "defaultValue": "\"m\""
            },
            "noHeadingBorder": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the border bottom from the heading"
                },
                "attribute": "no-heading-border",
                "reflect": false,
                "defaultValue": "false"
            },
            "noHeadingPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the padding from the heading"
                },
                "attribute": "no-heading-padding",
                "reflect": false,
                "defaultValue": "false"
            },
            "headingJustify": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "headingJustify",
                    "resolved": "\"center\" | \"end\" | \"start\"",
                    "references": {
                        "headingJustify": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/container/container.tsx",
                            "id": "src/components/container/container.tsx::headingJustify"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The heading justification"
                },
                "attribute": "heading-justify",
                "reflect": false,
                "defaultValue": "\"center\""
            },
            "noContentPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the padding from the content"
                },
                "attribute": "no-content-padding",
                "reflect": false,
                "defaultValue": "false"
            },
            "noContentGap": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the gap from the content"
                },
                "attribute": "no-content-gap",
                "reflect": false,
                "defaultValue": "false"
            },
            "noFooterPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the padding from the footer"
                },
                "attribute": "no-footer-padding",
                "reflect": false,
                "defaultValue": "false"
            },
            "footerJustify": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "footerJustify",
                    "resolved": "\"center\" | \"end\" | \"start\"",
                    "references": {
                        "footerJustify": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/container/container.tsx",
                            "id": "src/components/container/container.tsx::footerJustify"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The footer justification"
                },
                "attribute": "footer-justify",
                "reflect": false,
                "defaultValue": "\"end\""
            },
            "noBorderFooter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Removes the border top from the footer"
                },
                "attribute": "no-border-footer",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "hasSlottedContent": {},
            "hasFooterSlot": {},
            "hasOnlyHeading": {},
            "hasOnlyFooter": {}
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=container.js.map
